<template>
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th class="border-0">#</th>
        <th class="border-0">{{ $t('word.question.columns.question') }}</th>
        <th class="border-0" style="width: 150px">{{ $t('word.question.columns.level') }}</th>
        <th class="border-0" style="width: 200px">{{ $t('word.question.columns.options') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="questions.length === 0">
        <td colspan="4" class="text-center text-muted py-3">
          {{ $t('word.question.empty') }}
          <span class="text-primary ml-1" style="cursor:pointer" @click="$emit('add-row')">
            <i class="fas fa-plus" /> {{ $t('word.question.addFirst') }}
          </span>
        </td>
      </tr>

      <tr v-for="(row, index) in questions" :key="index">
        <td>{{ row.id || '-' }}</td>

        <td>
          <d-input
            v-if="row.isEditing || row.isNew"
            v-model="row.question"
            :placeholder="$t('word.question.placeholder')"
          />
          <span v-else>{{ row.question }}</span>
        </td>

        <td>
          <d-select
            v-if="row.isEditing || row.isNew"
            v-model="row.level"
            :options="levels"
            value-field="slug"
            text-field="label"
            class=""
          />
          <span v-else>
            {{ levelLabel(row.level) }}
          </span>
        </td>

        <td>
          <d-button-group v-if="row.isEditing || row.isNew" class="buttons">
            <d-button
              v-if="row.question && row.question.trim()"
              size="sm"
              class="btn-primary"
              @click.prevent="save(row)"
            >
              <i class="fas fa-save"/>
              <span class="d-none d-lg-inline"> {{ $t('shared.actions.save') }}</span>
            </d-button>
            <d-button
              size="sm"
              class="btn-secondary"
              @click.prevent="cancel(row)"
            >
              <i class="fas fa-times"/>
              <span class="d-none d-lg-inline"> {{ $t('shared.actions.cancel') }}</span>
            </d-button>
          </d-button-group>

          <d-button-group v-else class="buttons">
            <d-button
              size="sm"
              class="btn-warning"
              @click.prevent="startEdit(row)"
            >
              <i class="fas fa-pencil-alt"/>
              <span class="d-none d-lg-inline"> {{ $t('shared.actions.edit') }}</span>
            </d-button>
            <d-button
              size="sm"
              class="btn-danger"
              @click.prevent="$emit('deleted', row)"
            >
              <i class="fas fa-trash"/>
              <span class="d-none d-lg-inline"> {{ $t('shared.actions.delete') }}</span>
            </d-button>
          </d-button-group>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapActions } from 'vuex';
import PuzzleService from '_services/rest/modules/puzzle';

export default {
  name: 'question-table',
  props: {
    questions: { type: Array, default: () => [] },
    wordId: { type: Number, default: null },
    levels: { type: Array, default: () => [] },
  },
  methods: {
    ...mapActions(['activeAlert']),
    levelLabel(slug) {
      const found = this.levels.find(l => l.slug === slug);
      return found ? found.label : slug;
    },
    startEdit(row) {
      this.$set(row, 'isEditing', true);
      this.$set(row, 'original', { ...row });
    },
    cancel(row) {
      if (row.isNew) {
        this.$emit('deleted', row);
        return;
      }
      Object.assign(row, row.original);
      this.$set(row, 'isEditing', false);
    },
    save(row) {
      const payload = {
        id: row.id,
        word_id: this.wordId,
        question: row.question.trim(),
        size_id: row.size_id || 3,
        level: row.level || 'medium',
      };

      const request = row.id
        ? PuzzleService.editQuestion(payload)
        : PuzzleService.saveQuestion(payload);

      request
        .then(response => {
          if (!row.id) row.id = response.id;
          this.$set(row, 'isEditing', false);
          this.$set(row, 'isNew', false);
          this.activeAlert({
            message: payload.id
              ? this.$t('word.alert.questionUpdated')
              : this.$t('word.alert.questionCreated'),
            theme: 'success',
          });
          this.$emit('saved', row, response);
        })
        .catch(() => {
          this.activeAlert({ message: this.$t('word.alert.questionSaveError'), theme: 'danger' });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.input-hidden {
  width: 100%;
  border: 0;
  padding: 0;
  color: #3D5170;
  font-size: 15px;
  background: transparent;

  &:focus {
    outline: none;
    box-shadow: none;
  }
}
</style>
